import { IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { CellTypes, RequiredColumnsEnum } from '.';
import { Exclude, Type } from 'class-transformer';
import { Currency } from '../common';
import { SyncStatusDto } from '../integrations';
import { UsageAggregator } from '../usage/interfaces';

export interface PricingModelTable {
  rows: PricingModelTableRow[];
  columns: PricingModelTableColumn[];
}

export interface PricingModelTableColumn {
  id: string;
  type: CellTypes;
  title: string;
  refObjectId?: string;
  refObject?: any;
  isHidden: boolean;
  isHiddenInInvoice: boolean;
  isReadOnly: boolean;
}

export class ItemDto {
  constructor(partial?: Partial<ItemDto>) {
    Object.assign(this, partial);
  }

  @IsUUID('4')
  @IsOptional()
  id?: string;

  @IsString()
  name: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  category?: string;

  syncStatus?: SyncStatusDto[];
}

export class ItemPriceDto {
  constructor(partial?: Partial<ItemPriceDto>) {
    Object.assign(this, partial);
  }

  @IsUUID('4')
  @IsOptional()
  id?: string;

  @IsNumber()
  @Type(() => Number)
  price: number;

  @IsString()
  @IsOptional()
  itemId: string;

  @Type(() => ItemDto)
  item: ItemDto;

  @Exclude()
  pricingModelTabId?: string;

  currency?: Currency;
}

export interface PricingModelTableRow {
  cells: RowData;
  itemPriceId?: string;
  itemPrice?: ItemPriceDto;
  isHiddenInInvoice: boolean;
  isHidden: boolean;
  isSelectedForContract: boolean;
  index?: number;
}

export interface RowData {
  [columnName: string | RequiredColumnsEnum]: Cell;
}
export interface Cell {
  cellValue: string | number;
  cellType: CellTypes;
  formula?: string;
  cellId: string;
  isEditable?: boolean;
  refObjectId: string | undefined;
  refObject: any | undefined;
  prevCell?: Cell | undefined;
}
